module.exports = __webpack_public_path__ + "static/img/about_bg_03_zh.fae1182.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/about_bg_03_zh.png
// module id = QOTR
// module chunks = 34